var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-img',_vm._g(_vm._b({directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"previewable-img",attrs:{"src":_vm.srcModel,"alt":_vm.alt,"contain":"","height":_vm.height,"width":_vm.width},on:{"click":_vm.preview}},'v-img',attrs,false),on))]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('toolTips.preview'))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }